export default __webpack_public_path__ + "e4a21df2fa4a1dc62e4d98f86beb45dc.png";